import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import session_45global from "/app/web/app/middleware/session.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  session_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  guest: () => import("/app/web/app/middleware/guest.ts")
}